import { sanitizeNumber } from './format';

export const urlBaseWhatsapp = 'https://api.whatsapp.com/send?phone=';

export const urlSacNumbersWhatsapp = {
  default: '554740072374',
  cambio: '11960790400',
  support: '554740072374',
};

export function formatAdvisorWhatsAppLink({
  message,
  number,
}: FormatAdvisorWhatsAppLink) {
  const url = new URL('https://api.whatsapp.com/send');
  url.searchParams.append('phone', number.replace(NO_WHITESPACES_REGEX, ''));
  url.searchParams.append('text', message);
  return url.toString();
}

export const formatSecondariesWhatsAppMessage = (
  advisorName: string,
  { type, productName }: { type: string; productName: string }
) => {
  if (type === 'cetipado') {
    return `Olá ${advisorName.split(' ')[0]}, venho do EQI+ e gostaria de investir no produto ${productName}`;
  }
  if (type === 'wallet') {
    return `Olá ${advisorName.split(' ')[0]}, venho do EQI+ e gostaria de investir em um ou mais ativos da carteira ${productName}`;
  }

  return `Olá ${advisorName.split(' ')[0]}, venho do EQI+ e gostaria de investir no ativo ${productName}`;
};

const NO_WHITESPACES_REGEX = /\s/g;

type FormatAdvisorWhatsAppLink = {
  message: string;
  number: string;
};

export function getWhatsappAdvisorUrl(
  phoneNumber: string,
  screen: keyof typeof whatsappMessageHandsUpConfig,
  customMessage?: string
) {
  const encodedPhone = encodeURI(sanitizeNumber(phoneNumber));
  const message = customMessage || whatsappMessageHandsUpConfig[screen];
  return urlBaseWhatsapp + encodedPhone + '&text=' + message;
}

export const screenSacWhatsappEQI = [
  'goods_acquisition_consortium',
  'goods_acquisition_financing',
  'life_insurance',
];

export const whatsappMessageHandsUpConfig = {
  default: 'default',
  business_credit: 'Olá, tenho interesse em Crédito Empresarial',
  business_freeMarket: 'Olá, tenho interesse em Mercado Livre de Energia',
  credit_card: 'Olá, tenho interesse em Cartão de Crédito',
  exchange: 'Olá, tenho interesse em Câmbio',
  goods_acquisition_financing:
    'Olá, tenho interesse em Financiamento Imobiliário',
  goods_acquisition_homeEquity: 'Olá, tenho interesse em Home Equity',
  goods_acquisition_consortium: 'Olá, tenho interesse em Consórcio',
  invest: 'Olá, tenho interesse em Investir',
  life_insurance: 'Olá, tenho interesse em Seguro de Vida',
  pension: 'Olá, tenho interesse em Previdência',
  variable_income: 'Olá, tenho interesse em Renda Variável',
  consultancy: 'Olá, tenho interesse em Minha Assessoria',
  my_goals: 'Olá, tenho interesse em Meus Objetivos FP',
  my_retirement: 'Olá, tenho interesse em Minha Aposentadoria FP',
  my_net_worth: 'Olá, tenho interesse em Meu Patrimônio FP',
  patrimonial_protection: 'Olá, tenho interesse em Proteção Patrimonial FP',
  financial_control: 'Olá, tenho interesse em Controle Financeiro FP',
  investments_products: 'Olá, tenho interesse em Produtos de Investimentos',
  investments_cetipados: 'Olá, tenho interesse em Investimentos Cetipados',
  investiments_wallet: 'Olá, tenho interesse em Carteira de Investimentos',
  live_off_passive_income:
    'Oi, venho do EQI+ e gostaria de mais informações sobre a minha simulação do Vivendo de Renda',
};
